<div class="outer-container">
  <h3>{{ 'map.tools.snapAiRadar.title' | t }}</h3>
  <div class="fs-container">
    <div class="fs-row">
      <div class="snapCol" *ngIf="!resultsData">
        <mat-progress-bar *ngIf="isLoading" color="accent" mode="indeterminate"> </mat-progress-bar>
        <sn-form class="upload" *ngIf="!response && !isLoading" [fields]="formFields"></sn-form>
        <sn-flat-button
          *ngIf="response || isLoading"
          class="snap-buttons"
          color="accent"
          (click)="removeImage()"
        >
          <sn-icon fontSet="fal" fontIcon="fa-window-close"></sn-icon> {{ 'common.reset' | t }}
        </sn-flat-button>
        <sn-flat-button
          class="snap-buttons"
          *ngIf="!response && !isLoading"
          (click)="screenshot()"
          color="success"
        >
          <sn-icon fontSet="fal" fontIcon="fa-camera"></sn-icon> {{ 'common.screenshot' | t }}
        </sn-flat-button>
        <div class="image-div">
          <fs-ai-boxes
            *ngIf="response"
            (clickItem)="previewItem($event)"
            (select)="select($event)"
            [detections]="response.detection.detections"
            [resolution]="response.detection.resolution"
          >
            <img class="previewImg" [src]="sanitizeImg(dataUrl)" />
          </fs-ai-boxes>
        </div>
      </div>

      <div class="fs-container" *ngIf="resultsData">
        <mat-card class="hovered-item">
          <sn-icon-button (click)="removeImage()">
            <sn-icon icon="close"></sn-icon>
          </sn-icon-button>
          <mat-card-content>
            <fs-sentry-results-component
              [pursuitMode]="true"
              [inputValue]="resultsData"
            ></fs-sentry-results-component>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="snapCol2">
        <mat-card class="hovered-item3" *ngIf="item && !resultsData">
          <mat-card-header>
            <mat-card-title>{{ transform(item.label) }}</mat-card-title>
            <mat-card-subtitle>
              <mat-progress-bar
                color="accent"
                mode="determinate"
                [value]="item.confidence"
                [matTooltip]="(item.confidence | fsNumber : '1.0-2') + '%'"
              ></mat-progress-bar>
            </mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <div class="att" *ngFor="let att of item.metadata?.attributes">
              <strong>{{ transform(att.label) }}</strong>
              <mat-progress-bar
                color="accent"
                mode="determinate"
                [value]="att.confidence"
                [matTooltip]="(att.confidence | fsNumber : '1.0-2') + '%'"
              >
              </mat-progress-bar>
            </div>
            <div class="att" *ngIf="item.metadata?.colorTop">
              <strong>{{ 'pursuit.snapAiRadar.colorTop' | t }}</strong>
              <div
                class="color-swatch"
                [matTooltip]="item.metadata?.colorTop.label"
                [style.background-color]="item.metadata?.colorTop.label"
              ></div>
              <mat-progress-bar
                color="accent"
                mode="determinate"
                [value]="item.metadata?.colorTop.confidence"
                [matTooltip]="(item.metadata?.colorTop.confidence | fsNumber : '1.0-2') + '%'"
              >
              </mat-progress-bar>
            </div>
            <div class="att" *ngIf="item.metadata?.colorBottom">
              <strong>{{ 'pursuit.snapAiRadar.colorBottom' | t }}</strong>
              <div
                class="color-swatch"
                [matTooltip]="item.metadata?.colorBottom.label"
                [style.background-color]="item.metadata?.colorBottom.label"
              ></div>
              <mat-progress-bar
                color="accent"
                mode="determinate"
                [value]="item.metadata?.colorBottom.confidence"
                [matTooltip]="(item.metadata?.colorBottom.confidence | fsNumber : '1.0-2') + '%'"
              >
              </mat-progress-bar>
            </div>
            <div class="att" *ngIf="item.metadata?.carColor">
              <strong>{{ 'pursuit.snapAiRadar.carColor' | t }}</strong>
              <div
                class="color-swatch"
                [matTooltip]="item.metadata?.carColor.label"
                [style.background-color]="item.metadata?.carColor[0].label"
              ></div>
              <mat-progress-bar
                color="accent"
                mode="determinate"
                [value]="item.metadata?.carColor[0].confidence"
                [matTooltip]="(item.metadata?.carColor[0].confidence | fsNumber : '1.0-2') + '%'"
              >
              </mat-progress-bar>
            </div>
            <div class="att" *ngIf="item.metadata?.vehicleType">
              <strong>{{ 'pursuit.snapAiRadar.vehicleType' | t }}: {{ item.metadata?.vehicleType[0].label }}</strong>
              <mat-progress-bar
                color="accent"
                mode="determinate"
                [value]="item.metadata?.vehicleType[0].confidence"
                [matTooltip]="(item.metadata?.vehicleType[0].confidence | fsNumber : '1.0-2') + '%'"
              >
              </mat-progress-bar>
            </div>
            <mat-card-actions>
              <button mat-button (click)="createArray()" color="success">{{ 'pursuit.snapAiRadar.viewResults' | t }}</button>
            </mat-card-actions>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
</div>
